import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "本部一括" },
  { value: 2, text: "店舗単位" },
]);
